import fetch, {doGet} from '../../tools/axios'

export default {
  getStoryList (page, id, keyword = '', cb) {
    return fetch('get', `/stories?page=${page}&category_id=${id || ''}&keyword=${keyword}`, {}, (data) => {
      cb(data)
    })
  },
  getStoryDetail (id, cb) {
    return fetch('get', `/stories/${id}`, {}, cb)
  },
  getStoryDetailComments (id, page, perPage, cb) {
    return fetch('get', `/comments?type=story&story_id=${id}&page=${page}&perPage=${perPage}`, {}, cb)
  },
  readStory (id, cb) {
    return fetch('post', `/analysis/story/${id}/read`, {}, cb)
  },
  voteUpStory (id, cb) {
    return fetch('post', `/stories/${id}/vote_up`, {}, (data) => {
      cb(data)
    })
  },
  deleteComment (id, cb) {
    return fetch('post', `/comments/${id}/remove`, {}, (data) => {
      cb(data)
    })
  },
  getStoryVotes (id, page, perPage) {
    return doGet(`/stories/${id}/votes`, {
      page,
      perPage
    })
  }
}
